import { useTranslation } from 'react-i18next';
import { ControlledTextInputContainer } from 'shared-widget-components/src/components/ControlledInputs/ControlledTextInput';
import { useFormContext } from 'shared-widget-components/src/providers/FormContextProvider';
import { useSubscribeForm } from './hooks/useSubscribeForm';
import { SubscribeButton } from './SubscribeButton';
import { CheckboxContainer } from './CheckboxContainer';

interface SubscribeFormProps {
  textColor: string;
  buttonColor: string;
  buttonTextColor: string;
  // a sikeres feliratkozás állapotát állítja
  setSuccess: (value: boolean) => void;
}

const SubscribeForm = ({ textColor, buttonColor, buttonTextColor, setSuccess }: SubscribeFormProps) => {
  const { register } = useFormContext();
  const { t } = useTranslation();

  const { nameError, emailError, dataPolicyError, customerAgeError, submitForm } = useSubscribeForm({ setSuccess });

  return (
    <div className='flex w-full'>
      <div className='flex w-full flex-col'>
        <div className='flex min-[350px]:flex-col lg:flex-row w-full mb-2'>
          <div className='flex flex-col min-[350px]:w-full min-[350px]:gap-[4px] md:gap-0 lg:w-1/3 min-[350px]:mr-0 lg:mr-[12px]'>
            <ControlledTextInputContainer inputKey='name' register={register} placeholder={t('subscribeWidget.name')} isTextArea={false} width='100%' height='44px' />
            {nameError && <p className='text-red-500'>{nameError}</p>}
          </div>
          <div className='flex flex-col min-[350px]:w-full lg:w-2/3 min-[350px]:mr-0 lg:mr-[12px]'>
            <ControlledTextInputContainer inputKey='email' register={register} placeholder={t('subscribeWidget.email')} isTextArea={false} width='100%' height='44px' />
            {emailError && <p className='text-red-500'>{emailError}</p>}
          </div>
          <div className='min-[350px]:hidden lg:flex'>
            <SubscribeButton buttonColor={buttonColor} buttonTextColor={buttonTextColor} submitForm={submitForm} />
          </div>
        </div>
        <CheckboxContainer buttonColor={buttonColor} textColor={textColor} dataPolicyError={dataPolicyError} customerAgeError={customerAgeError} />
        <div className='min-[350px]:flex lg:hidden'>
          <SubscribeButton buttonColor={buttonColor} buttonTextColor={buttonTextColor} submitForm={submitForm} />
        </div>
      </div>
    </div>
  );
};

export default SubscribeForm;
